import { Stack, Typography } from '@mui/material';
import React from 'react';

type CalendarColumnHeaderProps = {
  date: Date;
  label: string; // unused, but provided by react-big-calendar
  localizer: {
    format: (date: Date, format: string) => string;
  };
};

const CalendarColumnHeader = ({ date, localizer }: CalendarColumnHeaderProps) => {
  const dayName = localizer.format(date, 'dddd');
  const capitalizedDayName = dayName.charAt(0).toUpperCase() + dayName.slice(1);
  const dayNumber = localizer.format(date, 'D');
  const isCurrentDay = localizer.format(date, 'YYYY-MM-DD') === localizer.format(new Date(), 'YYYY-MM-DD');
  return (
    <Stack py={1} alignItems='center' sx={{ position: 'relative' }}>
      <Typography
        fontWeight={700}
        px={1}
        color={isCurrentDay ? 'primary.main' : 'text.primary'}
        sx={{ textAlign: 'center' }}
      >
        {capitalizedDayName}
      </Typography>
      <Typography
        variant='subtitle2'
        color={isCurrentDay ? 'primary.main' : 'text.secondary'}
        px={1}
        sx={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)' }}
      >
        {dayNumber}
      </Typography>
    </Stack>
  );
};
export default CalendarColumnHeader;
